import { render, staticRenderFns } from "./LostConnection.vue?vue&type=template&id=60a547a2&scoped=true&"
import script from "./LostConnection.vue?vue&type=script&lang=js&"
export * from "./LostConnection.vue?vue&type=script&lang=js&"
import style0 from "./LostConnection.vue?vue&type=style&index=0&id=60a547a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a547a2",
  null
  
)

export default component.exports